import { sound } from '@pixi/sound';

import { PixiAssets } from '../../jackpot/helpers';
import { rootStore } from '../../store';


export const SoundTypes = {
  JackpotSymbolSound: 'JackpotSound',
  JackpotBackgroundMusic: 'JackpotBackgroundMusic',
  JackpotSceneTransition: 'SceneTransition',
  JackpotSuitAppearance: 'SuitAppearance',
  JackpotSuitTransfer: 'SuitTransfer',
  JackpotWinPopUp: 'WinPopUp',
  OpenWheel: 'openWheel',
  WheelWinPopup: 'wheelWinPopup',
  WheelSpinning: 'wheelSpinning',
  SpinWheelButton: 'spinWheelButton',
};

export const soundOptions = [
  {
    path: 'sounds/jackpotBackgroundMusic.mp3',
    name: SoundTypes.JackpotBackgroundMusic,
    autoplay: false,
    html5: true,
    singleInstance: true
  },
  {
    path: 'sounds/sceneTransition.mp3',
    name: SoundTypes.JackpotSceneTransition,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/suitAppearance.mp3',
    name: SoundTypes.JackpotSuitAppearance,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/suitTransfer.mp3',
    name: SoundTypes.JackpotSuitTransfer,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/winPopUp.mp3',
    name: SoundTypes.JackpotWinPopUp,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/openWheel.mp3',
    name: SoundTypes.OpenWheel,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wheelWinPopup.mp3',
    name: SoundTypes.WheelWinPopup,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wheelSpinning.mp3',
    name: SoundTypes.WheelSpinning,
    autoplay: false,
    loop: true,
    singleInstance: true,
  },
  {
    path: 'sounds/spinWheelButton.mp3',
    name: SoundTypes.SpinWheelButton,
    autoplay: false,
    singleInstance: true,
  },
];

class SoundService {
  soundListNames = [];
  soundResources = [];
  // Queue of { name, config, fromStart } waiting for AudioContext unlock.
  _pendingPlays = [];
  _audioUnlocked = false;

  constructor() {
    // Unlock AudioContext on first user gesture and flush pending sounds.
    const unlock = () => {
      sound.context.refresh();
      this._audioUnlocked = true;
      document.removeEventListener('pointerdown', unlock);
      document.removeEventListener('keydown', unlock);
      this._flushPending();
    };
    document.addEventListener('pointerdown', unlock);
    document.addEventListener('keydown', unlock);
  }

  _flushPending = () => {
    const pending = this._pendingPlays.splice(0);
    pending.forEach(({ name, config, fromStart }) => {
      if (fromStart) {
        this.playFromStart(name, config);
      } else {
        this.play(name, config);
      }
    });
  };

  setSoundResources = (resources) => {
    this.soundResources = resources;
    this.soundListNames = resources.map((el) => el.name);
  };

  loadSoundResources = async () => {
    // IMPORTANT: You must add the assets to Pixi before loading them by name
    this.soundResources.forEach((resource) => {
      PixiAssets.add(resource.name, resource.path);
    });

    // Now load them all at once
    await PixiAssets.load(this.soundListNames);
    console.log("All sounds loaded into PixiAssets");
  };

  resumeAudioContext = () => {
    if (sound.context.audioContext.state === 'suspended') {
      sound.context.audioContext.resume().then(() => {
        console.log("Parent context resumed via Child click proxy!");
      });
    }
  };

  play = async (name, config = {}) => {
    if (!rootStore.gameStore.soundEnabled) return;

    // AudioContext not yet unlocked — queue and wait for first user gesture.    
    if (!this._audioUnlocked && sound.context.audioContext?.state === 'suspended') {
      this._pendingPlays.push({ name, config, fromStart: false });
      return;
    }

    try {
      const soundInstance = PixiAssets.get(name);
      if (soundInstance && typeof soundInstance.play === 'function') {
        console.log(`[SoundService.play] Playing sound: "${name}" with config:`, config);

        return await soundInstance.play(config);
      } else {
        console.error(`[SoundService.play] "${name}" NOT FOUND in PixiAssets`);
      }
    } catch (e) {
      console.error(`[SoundService.play] "${name}" ERROR:`, e);
    }
  };

  stop = async (name) => {
    // Also remove from pending queue if sound was waiting.
    this._pendingPlays = this._pendingPlays.filter((p) => p.name !== name);
    const soundInstance = PixiAssets.get(name);
    console.log(`[SoundService.stop] Stopping sound: "${name}"`);
    if (soundInstance) soundInstance.stop();
  };

  stopAll = () => {
    sound.stopAll();
  };

  // ... rest of your methods
}
const soundService = new SoundService();

export { SoundTypes as soundTypes, soundService };
